export default function qidsScoreDescription(number: number) {
  if (number <= 5) {
    return "pas de dépression";
  } else if (number <= 10) {
    return "dépression légère";
  } else if (number <= 15) {
    return "dépression modérée";
  } else if (number <= 20) {
    return "dépression sévère";
  } else if (number <= 27) {
    return "dépression très sévère";
  }
  return "Le score ne semble pas être valide.";
}
